import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import { Menu } from '@instructure/ui-menu';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import { processNewMathInElem } from '@instructure/quiz-rce';
import t from '@instructure/quiz-i18n/es/format-message';

// Temporary file to prevent focus issues due to popovermenu
var Category = /*#__PURE__*/function (_Component) {
  function Category() {
    var _this;
    _classCallCheck(this, Category);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Category, [].concat(args));
    _defineProperty(_this, "state", {
      isFocused: false
    });
    _defineProperty(_this, "onToggle", function () {
      _this.setState({
        isFocused: !_this.state.isFocused
      });
    });
    _defineProperty(_this, "handlePopoverRef", function (node) {
      _this.popoverRef = node;
    });
    return _this;
  }
  _inherits(Category, _Component);
  return _createClass(Category, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.isFocused !== nextState.isFocused || this.props.userResponse.length !== nextProps.userResponse.length;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$popoverRef;
      if ((_this$popoverRef = this.popoverRef) !== null && _this$popoverRef !== void 0 && _this$popoverRef._contentElement) {
        processNewMathInElem(this.popoverRef._contentElement);
      }
    }

    // ===========
    //   RENDER
    // ===========
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        styles = _this$props.styles,
        itemBody = _this$props.itemBody,
        categoryTrigger = _this$props.categoryTrigger,
        categoryContent = _this$props.categoryContent;
      return jsx("div", {
        css: styles.categoryContainer
      }, jsx(ScreenReaderContent, null, t('Category')), jsx(Text, {
        color: "primary"
      }, itemBody), jsx(Menu, {
        trigger: categoryTrigger,
        onToggle: this.onToggle,
        popoverRef: this.handlePopoverRef
      }, categoryContent));
    }
  }]);
}(Component);
_defineProperty(Category, "propTypes", {
  itemBody: PropTypes.string.isRequired,
  userResponse: PropTypes.array.isRequired,
  categoryTrigger: PropTypes.element.isRequired,
  categoryContent: PropTypes.array.isRequired,
  styles: PropTypes.object
});
export { Category as default };